import React from 'react';

import { useGetPortalUserConfig, useSaveUserConfigParam } from 'queries/portalUser';

interface IUseGridExpandResult {
  isExpanded: boolean;
  onToggleExpand: () => void;
}

export const useGridExpand = (pageKey?: string): IUseGridExpandResult => {
  const { data: portalUser } = useGetPortalUserConfig();
  const { mutate: saveUserConfigParam } = useSaveUserConfigParam();

  const isExpanded = !!(pageKey && portalUser?.settings.pages[pageKey]?.expandTable);

  const onToggleExpand = React.useCallback(() => {
    if (!pageKey) {
      return;
    }

    saveUserConfigParam({ expandTable: !isExpanded, pageKey });
  }, [pageKey, isExpanded, saveUserConfigParam]);

  return { isExpanded, onToggleExpand };
};
